import GLightbox from 'glightbox'
export default class Lightbox {
  constructor() {
    const throttle = function (callback, delay) {
      let last
      let timer
      return function () {
        let context = this
        let now = +new Date()
        let args = arguments
        if (last && now < last + delay) {
          // le délai n'est pas écoulé on reset le timer
          clearTimeout(timer)
          timer = setTimeout(function () {
            last = now
            callback.apply(context, args)
          }, delay)
        } else {
          last = now
          callback.apply(context, args)
        }
      }
    }
    let calculWidthForImg = () => {
      let links = document.querySelectorAll('.viewBig')
      links.forEach((link) => {
        let sizeTablet = link.dataset['urltablet']
        let sizeDesktop = link.dataset['urldesktop']
        if (window.innerWidth >= 768 && window.innerWidth < 1024) {
          link.setAttribute('href', sizeTablet)
        } else if (window.innerWidth >= 1024) {
          link.setAttribute('href', sizeDesktop)
        }
      })
    }

    calculWidthForImg()
    if(document.querySelector('.js-openGallery')) {
      let btnOpenBox = document.querySelectorAll('.js-openGallery')
      btnOpenBox.forEach((btn) => {
        let parent = btn.parentNode.parentNode
        let gallery = Array.from(parent.querySelectorAll('.imgGallery'))
        GLightbox({
          touchNavigation: true,
          loopAtEnd: false,
          openEffect: 'fade'
        })
        const myGallery = GLightbox({
          elements: gallery
        })
        btn.addEventListener('click', (e) => {
          e.preventDefault()
          myGallery.open()
          console.log(myGallery)
        })
      })
    }

    window.addEventListener('resize', throttle(function () {
      calculWidthForImg()
    }, 600))
  }
}






